export default __webpack_public_path__ + "static/SanFranciscoText-Regular-dd020ca00cc3939fa297d326e0b67f31.eot";